<template>
  <div class="home">
    <JournalTemplateList v-show="listView" @newJournal="onClickNewFromList" @editJournal="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <JournalTemplateForm v-show="formView" :journal="journal" @backClicked="onBackChild" />
  </div>
</template>

<script>
// @ is an alias to /src
import JournalTemplateList from '@/components/journal/JournalTemplateList.vue'
import JournalTemplateForm from '@/components/journal/JournalTemplateForm.vue'
import { mapState } from 'vuex'

export default {
  name: 'JournalTemplate',
  components: {
    JournalTemplateList,
    JournalTemplateForm
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser
    })
  },
  data () {
    return {
      journal: {
        id: null,
        name: null,
        description: null,
        branch_no: null,
        company_no: null,
        details: [{
          id: null,
          template_id: null,
          account_code: null,
          remark: null,
          method: null
        }]
      },
      listView: true,
      formView: false
    }
  },
  methods: {
    onClickNewFromList: function () {
      this.journal = {
        id: null,
        name: null,
        description: null,
        branch_no: this.authUser.branch_no,
        company_no: this.authUser.company_no,
        details: [{
          template_id: null,
          account_code: null,
          remark: null,
          method: null
        }]
      }
      this.listView = false
      this.formView = true
    },
    onClickEditFromList: function (value) {
      this.journal = value
      this.listView = false
      this.formView = true
    },
    async onBackChild () {
      this.listView = true
      this.formView = false
      this.journal = {
        id: null,
        name: null,
        description: null,
        company_no: null,
        branch_no: null,
        details: [{
          id: null,
          template_id: null,
          account_code: null,
          remark: null,
          method: null
        }]
      }
      this.$refs.refreshList.refreshJournal()
    }
  },
  mounted () {
    this.$store.dispatch('getAccountList')
    this.$store.dispatch('getCompanyList')
  }
}
</script>
